/**
 * Google Ads conversion tracking — loads only when advertising consent is granted.
 * Set REACT_APP_GOOGLE_ADS_CONVERSION_ID (AW-...) and REACT_APP_GOOGLE_ADS_CONVERSION_LABEL.
 */

const GOOGLE_ADS_ID = (process.env.REACT_APP_GOOGLE_ADS_CONVERSION_ID || '').trim();
const GOOGLE_ADS_LABEL = (process.env.REACT_APP_GOOGLE_ADS_CONVERSION_LABEL || '').trim();

let googleAdsTagLoaded = false;

function loadGoogleAdsGtag() {
  if (googleAdsTagLoaded || typeof window === 'undefined' || !GOOGLE_ADS_ID) return;
  try {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GOOGLE_ADS_ID)}`;
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }
    window.gtag('js', new Date());
    window.gtag('config', GOOGLE_ADS_ID);
    googleAdsTagLoaded = true;
  } catch (_) {
    // Never allow third-party analytics bootstrapping to break app startup.
  }
}

/**
 * @param {boolean} advertisingAllowed
 */
export function initGoogleAds(advertisingAllowed) {
  if (!advertisingAllowed || !GOOGLE_ADS_ID) return;
  loadGoogleAdsGtag();
}

/**
 * @returns {string|null}
 */
export function getGoogleAdsSendTo() {
  if (!GOOGLE_ADS_ID || !GOOGLE_ADS_LABEL) return null;
  return `${GOOGLE_ADS_ID}/${GOOGLE_ADS_LABEL}`;
}

/**
 * @param {{ value: number, currency: string, transactionId: string }} params
 */
export function trackGoogleAdsPurchase({ value, currency, transactionId }) {
  const sendTo = getGoogleAdsSendTo();
  if (!sendTo || typeof window.gtag !== 'function') return;
  if (!Number.isFinite(value) || value < 0 || !currency || !transactionId) return;
  window.gtag('event', 'conversion', {
    send_to: sendTo,
    value,
    currency: String(currency).toUpperCase(),
    transaction_id: transactionId,
  });
}

export function isGoogleAdsConfigured() {
  return Boolean(GOOGLE_ADS_ID && GOOGLE_ADS_LABEL);
}

export function getGoogleAdsConversionId() {
  return GOOGLE_ADS_ID;
}

export function resetGoogleAdsForTests() {
  googleAdsTagLoaded = false;
}
